import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { FertilizerProductId } from 'services/fertilizerProducts/types';
import { makeSelectProductReEntryPeriodDays } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: FertilizerProductId;
}

type Props = OwnProps;

export default function ProductReEntryPeriodDaysTableCell(
    props: Props
): React.ReactElement {
    const productReEntryPeriodDays = useSelector((state: AppState) =>
        makeSelectProductReEntryPeriodDays()(state, props)
    );

    return <TableCell>{productReEntryPeriodDays}</TableCell>;
}
